import { PropsWithChildren, ReactNode } from "react"

import { InfoTooltip } from "../InfoTooltip"
import { LabelError } from "./LabelError"

export type LabelProps = {
  label?: ReactNode
  inputId?: string | undefined
  subLabel?: ReactNode[]
  secondaryLabel?: ReactNode
  infoMessage?: string
  errorMessage?: string
  containerClassName?: string
}

export function Label(props: PropsWithChildren<LabelProps>) {
  const {
    label,
    subLabel,
    secondaryLabel,
    infoMessage,
    errorMessage,
    inputId,
    containerClassName,
    children,
  } = props
  return (
    <div className={containerClassName}>
      {!!label && (
        <div className="mb-2">
          <div className="flex items-center gap-x-1">
            <label
              htmlFor={inputId}
              className="text-body color-default font-medium"
            >
              {label}
            </label>
            {!!secondaryLabel && (
              <label className="text-body color-subtler">
                {secondaryLabel}
              </label>
            )}
            {!!infoMessage && (
              <InfoTooltip content={infoMessage} placement="right-start" />
            )}
          </div>
          {subLabel}
        </div>
      )}
      {children}
      <LabelError errorMessage={errorMessage} inputId={inputId} />
    </div>
  )
}
